import { JOB_SET_JOBS, JOB_SET_IS_LOADED } from './jobsConstants';

import { updateAction, makeSetValueAction, makeAction, keyToValueAction } from '../utils';

// ------------ ACTIONS

const mutators = new Map();

const providers = {
  setJobs: keyToValueAction(mutators, JOB_SET_JOBS, 'jobs'),
  setIsLoaded: keyToValueAction(mutators, JOB_SET_IS_LOADED, 'isLoaded'),
};

// -------------- RESOLVER

const initialValue = {
  jobs: [],
  categories: [],
  isLoaded: false,
};

const resolver = (state = initialValue, { type, payload }) => {
  if (!mutators.has(type)) {
    return state;
  }

  return mutators.get(type)(state, payload);
};

export default resolver;

const actions = Array.from(mutators.keys());

export {
  actions,
  providers,
};
